import React from 'react';

import withPensionExpertTier from '../../util/pensionExpertTier/withPensionExpertTier';

import NotificationBanner from '../NotificationBanner/NotificationBanner';

const MetlifeCustomerNotification = ({ isPoolExpert, expertRoleTitle }) => {
  return (
    <NotificationBanner
      alertCategory={'Blue'}
      alertTitle={''}
      expandableAlertDescription={
        isPoolExpert
          ? 'Please contact our Pension Experts to discuss this pension.'
          : `Please contact your dedicated ${expertRoleTitle} to discuss this pension.`
      }
    />
  );
};

export default withPensionExpertTier(MetlifeCustomerNotification);
